import '@/styles/application.css'
import { createApp } from 'vue'
import App from '@/App.vue'
import { router } from '@/router'
import { i18n } from '@/i18n'
import { installAppsignal } from '@/lib/appsignal'
import { captureSensitiveToken } from '@/lib/sensitiveTokens'
import { startAnalytics } from '@/lib/analytics'

captureSensitiveToken()
// Watches which page the visitor is on; only ever loads anything on the public
// website, and only for a visitor who has accepted (CookieNotice asks).
startAnalytics(router)

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('app')
  if (!el) return
  const app = createApp(App)
  installAppsignal(app)
  app.use(router).use(i18n).mount(el)
})
